import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import {
  getTransSalesOrderDownloadCommFile,
  getTransactionCommFiles,
  getTransactionCommunication,
  getTransactionUserNotes,
} from "../../../api/transaction-type";
import {
  salesOrderCommunicationActivitiesTable,
  salesOrderCommunicationFilesTable,
  salesOrderMessageTable,
  billCommunicationUserNotesTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  MenuItem,
  Tabs,
  Tab,
  FormControl,
  Select,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { Download } from "@mui/icons-material";
import useErrorHandler from "../../../hooks/useErrorHandler";
import { getTransactionMessage } from "../../../api/invoice";

export default function QuoteCommunication({ tabIndexP }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  // let obj = salesOrderCommunicationFilesTable.find(
  //   (o) => o.headerName === "Action"
  // );
  // addAdditionalColumn(obj, dispatch);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token) {
      getTransactionCommunicationData();
    }
  }, [user.token]);
  // function addAdditionalColumn(obj, dispatch) {
  //   if (obj === undefined) {
  //     salesOrderCommunicationFilesTable.unshift({
  //       headerName: "Action",
  //       field: "actions",
  //       maxWidth: 86,
  //       cellRendererFramework: (params) => (
  //         <Box>
  //           <Button
  //             className="actionIcon"
  //             onClick={() => {
  //               dispatch({ type: "DOWNLOADFILE", data: params.data });
  //             }}
  //           >
  //             <Download />
  //           </Button>
  //         </Box>
  //       ),
  //     });
  //   }
  // }

  // useEffect(() => {
  //   if (!dialogAction.type) return;
  //   switch (dialogAction.type) {
  //     case "DOWNLOADFILE":
  //       dispatch({ type: "" });
  //       setDialogOpen(true);
  //       getDownloadDocumentById(
  //         dialogAction.data.transaction_id,
  //         dialogAction.data.filename
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  // }, [dialogAction]);
  const getDownloadDocumentById = (id, filename, folder) => {
    if (!filename) {
      snackbar.showInfo("No files.");
      return;
    }
    setDialogOpen(true);
    setPercentComplete(0);

    const options = {
      // Defines options for request

      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      // For a file (e.g. image, audio), response should be read to Blob (default to JS object from JSON)

      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getTransSalesOrderDownloadCommFile(
      user?.token,
      options,
      {
        id: id,
        // folderpath: isFilename === true ? "" : filename,
        // filename: isFilename === true ? encodedFilename : "",
      },
      {
        filename: filename,
        folderpath: folder,
      }
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  async function getTransactionCommunicationData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCommunication(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getTransactionMessageData() {
    try {
      const { data } = await getTransactionMessage(user.token, {
        id: params.docNo,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
    setRowData([]);
  }

  async function getTransactionFilesData() {
    try {
      const { data } = await getTransactionCommFiles(user.token, {
        id: params.docNo,
      });

      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  async function getTransactionUserNotesData() {
    try {
      const { data } = await getTransactionUserNotes(user.token, {
        id: params.docNo,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

return (
    <>
      {loading ? (
        <>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
    <>
      <Box>
        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
            px: 2,
          }}
        >
          <Grid container m={1}>
            <Grid item xs={12} sm={6}>
              <FormGroup>
                <FormControlLabel
                  control={<checkbox disabled />}
                  label="EMAIL SENT"
                />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormGroup>
                <FormControlLabel
                  control={<checkbox disabled />}
                  label="DO NOT SEND EMAIL "
                />
              </FormGroup>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <p className="titleHeading">Messages</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid container m={1}>
            <Grid item xs={12} sm={12} md={6} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.tobeprinted === "" ||
                        rowData?.tobeprinted === "F"
                          ? false
                          : true
                      }
                    />
                  }
                  label="TO BE PRINTED"
                />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={12} md={6} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.available_in_customer_center === "" || rowData?.available_in_customer_center === "F"
                          ? false
                          : true
                      }
                    />
                  }
                  label="AVAILABLE IN CUSTOMER CENTER"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.tobefaxed === "" ||
                        rowData?.tobefaxed === "F"
                          ? false
                          : true
                      }
                    />
                  }
                  label="TO BE FAXED"
                />
              </FormGroup>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <p className="tFormlabel">CUSTOMER MESSAGE</p>
              <p className="tFormName">{rowData.message}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={6} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.tobeemailed === "" ||
                        rowData?.tobeemailed === "F"
                          ? false
                          : true
                      }
                    />
                  }
                  label="TO BE EMAILED"
                />
              </FormGroup>
            </Grid>
          </Grid>
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="Messages" />
            <Tab label="Activities" />
            <Tab label="Files" />
            <Tab label="User Notes" />
          </Tabs>
          {/*----------Messages------------*/}
          <TabPanel value={tabIndex} index={0}>
            <Box className="viewDetilsBox">
              {/* {rowData.map((d, i) => ( */}
              <Grid container>
                {/* <Grid item xs={12} sm={6} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label="TO BE PRINTED"
                      />
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label="TO BE E-MAILED"
                      />
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label=" TO BE FAXED"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6} className="m-b-10">
                    <p className="tFormlabel">CUSTOMER MESSAGE</p>
                    <p className="tFormName"></p>
                  </Grid> */}
                <Grid item xs={12} sm={6} md={6} className="m-b-10">
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Case Default</MenuItem>
                      <MenuItem value="search">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {/* ))} */}
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionMessageData}
              columns={salesOrderMessageTable}
              refreshCounter={0}
            />
          </TabPanel>
          {/*----------Activities------------*/}
          <TabPanel value={tabIndex} index={1}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2} py={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      STATUS
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      ACTIVITY TYPE
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  backgroundColor: "#bbd9e8",
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">New Event</Button>
                  <Button className="blue-button">Log Event</Button>
                  <Button className="blue-button">View History</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
              <AgGridPaginatedTable
                getTableRows={undefined}
                columns={salesOrderCommunicationActivitiesTable}
                refreshCounter={0}
              />
            </Box>
          </TabPanel>
          {/*----------Files------------*/}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <AgGridPaginatedTable
                getTableRows={getTransactionFilesData}
                columns={salesOrderCommunicationFilesTable}
                refreshCounter={0}
                onCellClicked={(params) => {
                  console.log("Prarams-===", params);
                  if (params.colDef.field === "filename") {
                    getDownloadDocumentById(
                      params.data.transaction_id,
                      params.data.filename,
                      params.data.folder
                    );
                  }
                  return;
                }}
              />
            </Box>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
              <DialogTitle>Download Progress</DialogTitle>
              <DialogContent>
                {downloadInProgress ? (
                  <>
                    <CircularProgress
                      variant="determinate"
                      value={percentComplete}
                      size={50}
                      thickness={10}
                      style={{ marginLeft: "60px" }}
                    />
                    <>{percentComplete + "%"}</>
                  </>
                ) : (
                  <></>
                )}
              </DialogContent>
              {/* ... (your existing dialog actions, if any) */}
            </Dialog>
          </TabPanel>
          {/* ----------User Notes------------ */}
          <TabPanel value={tabIndex} index={3}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2} py={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">New Note</Button>
                <Button className="blue-button">View History</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionUserNotesData}
              columns={billCommunicationUserNotesTable}
              refreshCounter={0}
            />
          </TabPanel>
        </Box>
      </Box>
    </>

  )
}
</>
)
}
